/* Contact form (§10H Part B): topic-aware fields, honeypot, and image attachments uploaded through the App Proxy
   the customizer uses (/apps/ringmaker-logs/upload → Shopify Files → CDN). The CDN URLs go into contact[Attachments],
   which Shopify appends to the contact e-mail. Images above 16 MP are downscaled to 4,096 px on the longest side
   before upload (Shopify rejects media over 25 MP). No dependencies. */
(function () {
var DUP_KEY = 'rs_popup_last_submit', DUP_WINDOW_MS = 60000, memLastSubmit = {};
function payloadFingerprint(form, hidden) {
  var id = form.id || form.getAttribute('name') || form.getAttribute('action') || 'contact';
  var emailEl = form.querySelector('[name="contact[email]"]');
  var bodyEl = form.querySelector('[name="contact[body]"], [name="contact[message]"], [data-message]');
  var attEl = hidden || form.querySelector('[name="contact[Attachments]"], [data-attachments]');
  var email = (emailEl && emailEl.value || '').trim().toLowerCase();
  var body = (bodyEl && bodyEl.value || '').trim().replace(/\s+/g, ' ');
  var att = (attEl && attEl.value || '').trim();
  if (!email && !body && !att) return '';
  return id + '|' + email + '|' + body + '|' + att;
}
function readLastMap() {
  var map = {};
  Object.keys(memLastSubmit).forEach(function (k) { map[k] = memLastSubmit[k]; });
  try {
    var raw = sessionStorage.getItem(DUP_KEY);
    if (raw) {
      var parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') {
        if (parsed.fp && typeof parsed.ts === 'number') {
          map[parsed.fp] = Math.max(map[parsed.fp] || 0, parsed.ts);
        } else if (parsed. entries && typeof parsed.entries === 'object') {
          Object.keys(parsed.entries).forEach(function (k) {
            map[k] = Math.max(map[k] || 0, parsed.entries[k] || 0);
          });
        }
      }
    }
  } catch (e) {}
  return map;
}
function recordLastSubmit(fp) {
  if (!fp) return;
  var now = Date.now();
  memLastSubmit[fp] = now;
  try {
    var map = readLastMap();
    map[fp] = now;
    sessionStorage.setItem(DUP_KEY, JSON.stringify({ fp: fp, ts: now, entries: map }));
  } catch (e) {}
}
function clearLastSubmit(fp) {
  if (!fp) return;
  delete memLastSubmit[fp];
  try {
    var raw = sessionStorage.getItem(DUP_KEY);
    if (raw) {
      var parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') {
        if (parsed.entries) delete parsed.entries[fp];
        if (parsed.fp === fp) { delete parsed.fp; delete parsed.ts; }
        sessionStorage.setItem(DUP_KEY, JSON.stringify(parsed));
      }
    }
  } catch (e) {}
}
function isRecentDuplicate(fp) {
  if (!fp) return false;
  var map = readLastMap();
  var ts = map[fp];
  return !!(ts && (Date.now() - ts) < DUP_WINDOW_MS);
}

function initContactForm(form) {
  if (!form || form.dataset.init) return; form.dataset.init = '1';
  var topic = form.querySelector('[data-topic]'), orderField = form.querySelector('[data-order-field]'), orderHint = form.querySelector('[data-order-hint]'), message = form.querySelector('[data-message]');
  var attach = form.querySelector('[data-attach]'), input = form.querySelector('[data-files]'), previews = form.querySelector('[data-previews]'), status = form.querySelector('[data-attach-status]'), hidden = form.querySelector('[data-attachments]'), submit = form.querySelector('[data-submit], button[type="submit"], input[type="submit"]'), hp = form.querySelector('[data-hp]');
  var labelSpan = submit && submit.querySelector('[data-submit-label]');
  var MAX = parseInt(attach && attach.dataset.max, 10) || 3, MAX_BYTES = 20 * 1024 * 1024, MAX_PIXELS = 16e6, MAX_SIDE = 4096;
  var PLACEHOLDERS = { 'help me': 'Tell us about the crest, logo or idea you have in mind, the finger and (if known) the ring size. Attach an image below and we will do the design work for free.', 'question': 'Ask anything about materials, engraving, sizes, delivery or pricing.', 'my order': 'Please include your order number and what you would like to change or know.', 'ring size': 'Tell us the size you measured, or ask us to send a free ring sizer.', 'resize': 'Tell us the current size, the size you need and your order number.', 'warranty': 'Describe what happened and attach a photo of the ring below.', 'wholesale': 'Tell us about your brand, audience and what you have in mind.' };
  var files = [];
  var submitLabel = submit ? (labelSpan ? labelSpan.textContent : submit.textContent) : '';
  if (submit && !submit.dataset.origLabel) submit.dataset.origLabel = submitLabel;
  function setSubmitText(txt) {
    if (!submit) return;
    if (labelSpan) labelSpan.textContent = txt;
    else submit.textContent = txt;
  }
  function getSubmitText() {
    if (!submit) return '';
    return labelSpan ? labelSpan.textContent : submit.textContent;
  }
  function ensureStatusEl() {
    if (status) {
      status.setAttribute('data-rs-submit-error', '');
      return status;
    }
    status = form.querySelector('[data-form-status], [data-rs-submit-error]');
    if (!status) {
      status = document.createElement('p');
      status.className = 'contact-form__attach-status';
      status.setAttribute('data-form-status', '');
      status.setAttribute('data-rs-submit-error', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.hidden = true;
      if (submit && submit.parentNode) submit.parentNode.insertBefore(status, submit);
      else form.appendChild(status);
    }
    return status;
  }
  function setStatus(text, isError) { var el = ensureStatusEl(); if (!el) return; el.textContent = text || ''; el.hidden = !text; el.classList.toggle('is-error', !!isError); }
  function sync() { if (hidden) hidden.value = files.filter(function (f) { return f.url; }).map(function (f) { return f.url; }).join('\n'); if (sending) return; var busy = files.some(function (f) { return f.status === 'uploading'; }); if (submit) { submit.disabled = busy; setSubmitText(busy ? 'Uploading…' : (submit.dataset.origLabel || submitLabel)); } }
  if (topic) { var onTopic = function () { var v = (topic.value || '').toLowerCase(); var orderTopic = /\border\b|resize|warranty/.test(v); /* whole word: "Question before ordering" is not an order topic (2026-10-01) */ if (orderField) orderField.hidden = !orderTopic; if (orderHint) orderHint.hidden = !orderTopic; if (message) { var key = Object.keys(PLACEHOLDERS).find(function (k) { return v.indexOf(k) === 0; }); message.placeholder = key ? PLACEHOLDERS[key] : 'Message *'; } }; topic.addEventListener('change', onTopic); onTopic(); }
  /* 2026-10-02: from the My order page's "Message us" (?topic=My order&order_number=6850) the topic is picked and the order number filled. */
  /* ?order= still read for links made before the rename; a renamed "My order" topic falls back to the first topic with the word "order". */
  try { var qp = new URLSearchParams(location.search), qt = (qp.get('topic') || '').toLowerCase(), qo = (qp.get('order_number') || qp.get('order') || '').replace(/[^0-9A-Za-z-]/g, '').slice(0, 20); if (!/\d/.test(qo)) qo = '';
    var opts = topic ? Array.prototype.filter.call(topic.options, function (o) { return o.value; }) : [], opt = qt && (opts.find(function (o) { return o.value.toLowerCase() === qt; }) || (/\border\b/.test(qt) && opts.find(function (o) { return /\border\b/i.test(o.value); })));
    if (opt) { topic.value = opt.value; if (typeof onTopic === 'function') onTopic(); } /* no synthetic change event: analytics tags could count it as the visitor starting the form */
    var oi = form.querySelector('#ContactForm-order'); if (oi && qo && !oi.value) oi.value = '#' + qo; if (qo && orderHint) orderHint.hidden = true; } catch (e) {}
  /* Downscale big raster images on a canvas; HEIC/PDF and small files pass through untouched. */
  function downscale(file) {
    if (!/^image\/(jpeg|png|webp)$/.test(file.type)) return Promise.resolve(file);
    return new Promise(function (resolve) { var img = new Image(); var url = URL.createObjectURL(file);
      img.onload = function () { URL.revokeObjectURL(url); var w = img.naturalWidth, h = img.naturalHeight; if (w * h <= MAX_PIXELS && Math.max(w, h) <= MAX_SIDE) return resolve(file); var k = Math.min(MAX_SIDE / Math.max(w, h), Math.sqrt(MAX_PIXELS / (w * h))); var c = document.createElement('canvas'); c.width = Math.round(w * k); c.height = Math.round(h * k); c.getContext('2d').drawImage(img, 0, 0, c.width, c.height); var type = file.type === 'image/png' ? 'image/png' : 'image/jpeg'; c.toBlob(function (blob) { resolve(blob ? new File([blob], file.name.replace(/\.[^.]+$/, type === 'image/png' ? '.png' : '.jpg'), { type: type }) : file); }, type, 0.92); };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(file); }; img.src = url; });
  }
  function upload(entry) {
    entry.status = 'uploading'; entry.el.classList.add('is-uploading'); sync();
    var shop = (window.Shopify && window.Shopify.shop) || location.host;
    return downscale(entry.file).then(function (f) { var fd = new FormData(); fd.append('file', f, f.name); fd.append('rm_session_id', 'contact-' + Date.now().toString(36)); return fetch(attach.dataset.endpoint + '?shop=' + encodeURIComponent(shop), { method: 'POST', body: fd }); })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) { if (!d || !d.url) throw new Error('no url'); entry.url = d.url; entry.status = 'done'; entry.el.classList.remove('is-uploading'); setStatus(files.filter(function (f) { return f.url; }).length + ' of ' + files.length + ' attached'); })
      .catch(function () { entry.status = 'error'; entry.el.classList.remove('is-uploading'); entry.el.classList.add('is-error'); setStatus('One file could not be uploaded. Remove it and try again, or email it to us.', true); })
      .then(sync);
  }
  function add(list) {
    Array.prototype.forEach.call(list, function (file) {
      if (files.length >= MAX) { setStatus('You can attach up to ' + MAX + ' files.', true); return; }
      if (file.size > MAX_BYTES) { setStatus(file.name + ' is over 20 MB.', true); return; }
      if (!/^image\//.test(file.type) && !/\.(heic|heif|pdf)$/i.test(file.name) && file.type !== 'application/pdf') { setStatus(file.name + ': images or PDF only.', true); return; }
      var li = document.createElement('li'); li.className = 'contact-form__preview';
      if (/^image\/(jpeg|png|webp|gif)$/.test(file.type)) { var img = document.createElement('img'); img.alt = ''; img.src = URL.createObjectURL(file); li.appendChild(img); } else { var d = document.createElement('div'); d.className = 'contact-form__preview-file'; d.textContent = file.name; li.appendChild(d); }
      var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'contact-form__preview-remove'; rm.setAttribute('aria-label', 'Remove ' + file.name); rm.textContent = '×'; li.appendChild(rm);
      var entry = { file: file, url: null, status: 'queued', el: li }; files.push(entry); previews.appendChild(li);
      rm.addEventListener('click', function () { files.splice(files.indexOf(entry), 1); li.remove(); setStatus(files.length ? files.filter(function (f) { return f.url; }).length + ' of ' + files.length + ' attached' : ''); sync(); });
      upload(entry);
    });
    if (input) input.value = '';
  }
  if (input) input.addEventListener('change', function () { add(input.files); });
  if (attach) { ['dragenter', 'dragover'].forEach(function (ev) { attach.addEventListener(ev, function (e) { e.preventDefault(); attach.classList.add('is-dragover'); }); }); ['dragleave', 'drop'].forEach(function (ev) { attach.addEventListener(ev, function (e) { e.preventDefault(); attach.classList.remove('is-dragover'); }); }); attach.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) add(e.dataTransfer.files); }); }
  /* 2026-10-04 (§10X item 2) + 2026-10-26 (#298 ATC-style double-tap + 60 s duplicate guard):
     - Immediate in-flight lock on submit (`sending = true`, `submit.disabled = true`, `aria-disabled="true"`, `aria-busy="true"`,
       `.is-sending`, `.rs-adding`, calm `"Sending…"` label swap preserving button geometry).
     - Client-side 60 s duplicate payload guard (`rs_popup_last_submit` in memory + `sessionStorage`) so re-submitting
       the exact same `(email, body, attachments)` within 60 s shows a calm confirmation without sending a duplicate message.
     - Re-enables the button cleanly if validation fails or a network/server error occurs so the customer can retry. */
  var sending = false, unlockTimer = null;
  function unlock() {
    sending = false; clearTimeout(unlockTimer);
    form.classList.remove('is-sending');
    form.removeAttribute('data-rs-sending');
    if (submit) {
      submit.disabled = files.some(function (f) { return f.status === 'uploading'; });
      submit.removeAttribute('aria-disabled');
      submit.removeAttribute('aria-busy');
      submit.classList.remove('is-sending', 'rs-adding');
      submit.style.opacity = '';
      submit.style.minWidth = '';
      if (getSubmitText() === 'Sending…') setSubmitText(submit.dataset.origLabel || submitLabel);
    }
  }
  function lock() {
    if (!submit || sending) return;
    sending = true;
    form.classList.add('is-sending');
    form.setAttribute('data-rs-sending', 'true');
    var rect = submit.getBoundingClientRect && submit.getBoundingClientRect();
    if (rect && rect.width > 0) submit.style.minWidth = Math.ceil(rect.width) + 'px';
    submit.disabled = true;
    submit.setAttribute('aria-disabled', 'true');
    submit.setAttribute('aria-busy', 'true');
    submit.classList.add('is-sending', 'rs-adding');
    submit.style.opacity = '.55';
    setSubmitText('Sending…');
    unlockTimer = setTimeout(unlock, 15000);
  }
  if (submit) submit.addEventListener('click', function (e) { if (sending) { e.preventDefault(); e.stopImmediatePropagation(); return false; } });
  form.addEventListener('submit', function (e) {
    if (sending) { e.preventDefault(); e.stopImmediatePropagation(); return false; }
    if (hp && hp.value) { e.preventDefault(); return; } /* honeypot filled: a bot */
    if (files.some(function (f) { return f.status === 'uploading'; })) { e.preventDefault(); setStatus('Please wait for the upload to finish.', true); return; }
    var failed = files.filter(function (f) { return f.status === 'error'; }); if (failed.length) { e.preventDefault(); setStatus('Remove the file that failed to upload, or email it to us.', true); return; }
    if (input && input.hasAttribute('data-required') && !files.some(function (f) { return f.url; })) { e.preventDefault(); setStatus('Please attach the image you want us to check.', true); return; }
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) { e.preventDefault(); if (typeof form.reportValidity === 'function') form.reportValidity(); return; }
    var fp = payloadFingerprint(form, hidden);
    if (isRecentDuplicate(fp)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      setStatus('Thanks for contacting us. We already received your message and will reply shortly.', false);
      return false;
    }
    var preventedBeforeBubble = e.defaultPrevented;
    recordLastSubmit(fp);
    lock();
    if (preventedBeforeBubble) return;
    window.addEventListener('submit', function onWinSubmit(ev) {
      if (ev !== e) return;
      if (e.defaultPrevented || typeof window.fetch !== 'function') return;
      e.preventDefault();
      var fd = new FormData(form);
      var action = form.getAttribute('action') || '/contact';
      var method = (form.getAttribute('method') || 'POST').toUpperCase();
      fetch(action, {
        method: method,
        body: fd,
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html,application/xhtml+xml' }
      }).then(function (res) {
        if (!res || (!res.ok && res.status >= 400)) throw new Error('HTTP ' + (res ? res.status : 'error'));
        /* The store's spam check answers with a redirect to /challenge (captcha). Nothing was sent yet, so no "Thanks":
           let the browser submit the form itself and show the captcha page, as it did before the fetch path (WC#939 c). */
        if (res.redirected && /\/challenge(?:[/?#]|$)/.test(res.url || '')) {
          clearLastSubmit(fp);
          unlock();
          form.submit();
          return;
        }
        unlock();
        setStatus('Thanks for contacting us. We usually get back to you the same day.', false);
      }).catch(function () {
        clearLastSubmit(fp);
        unlock();
        setStatus('Could not send your message right now. Please tap to try again.', true);
      });
    }, { once: true });
  });
  window.addEventListener('pageshow', unlock);
}
document.querySelectorAll('#ContactForm, form[data-contact-form]').forEach(initContactForm);
document.addEventListener('shopify:section:load', function () { document.querySelectorAll('#ContactForm, form[data-contact-form]').forEach(initContactForm); });
})();
